module.exports = __webpack_public_path__ + "img/banner-title.50e0f81f.png";